import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  inject
} from '@angular/core';
import { pupilModel } from '@exclusionmodule/models';
import { MessagingService } from '@oneeducation/app-core';
import { Subscription } from 'rxjs';
import { STUDENT_ENDPOINT } from '@shared/properties';
import { ApiServiceService, NotificationService } from '@oneeducation/app-core';

@Component({
  selector: 'app-student-summary',
  templateUrl: './student-summary.component.html',
  styleUrls: ['./student-summary.component.scss'],
  standalone: false
})
export class StudentSummaryComponent implements OnInit, OnDestroy {
  private readonly apiService = inject(ApiServiceService);
  private readonly notificationService = inject(NotificationService);
  private readonly messagingService = inject(MessagingService);

  @Input() pupilData: any;
  @Input() schoolId: any;
  @Output() goBack: EventEmitter<any> = new EventEmitter();
  pupils: pupilModel[];
  gender: any;
  lac: any;
  sen: any;
  currentlyExcluded: any;
  homeLa: any;
  upn: any;
  offRoleIndicator: any;
  alertSubscription: Subscription;
  isLoading: boolean;

  constructor() {
    this.alertSubscription = this.messagingService
      .getAlert()
      .subscribe((arg) => {
        if (arg.value?.toLowerCase() === 'refreshsummary') {
          this.ngOnInit();
        }
      });
  }

  ngOnInit() {
    this.getStudentSummaryDetails();
  }

  private getStudentSummaryRoute(studentId: number, schoolId: number) {
    return STUDENT_ENDPOINT.GetStudentSummary.replace(
      '{studentId}',
      studentId?.toString()
    ).replace('{schoolId}', schoolId?.toString());
  }

  private getStudentSummaryDetails() {
    this.isLoading = true;
    const apiRoute = this.getStudentSummaryRoute(
      this.pupilData.studentId,
      this.schoolId
    );
    this.apiService.get<any>(apiRoute, '').subscribe({
      next: (x: any) => {
        if (parseInt(x.statusCode) === 200) {
          this.isLoading = false;
          this.currentlyExcluded = x.student.isOffRoll
            ? '-'
            : x.student.currentlyExcluded
              ? 'Yes'
              : 'No';
          this.gender =
            x.student.gender === 'M'
              ? 'Male'
              : x.student.gender === 'F'
                ? 'Female'
                : x.student.gender;
          this.upn = x.student.upn ? x.student.upn : 'None';
          this.offRoleIndicator = x.student.isOffRoll ? '(Off-roll)' : '';
          this.lac = x.student.isOffRoll
            ? '-'
            : this.pupilData.lac
              ? 'Yes'
              : 'No';
          this.sen = x.student.isOffRoll
            ? '-'
            : this.pupilData.sen
              ? this.pupilData.sen
              : 'None';
          this.homeLa = x.student.isOffRoll
            ? '-'
            : this.pupilData.homeLa
              ? this.pupilData.homeLa
              : 'None';
        }
      },
      error: () => {
        this.notificationService.showError('Error getting student summary');
        this.isLoading = false;
      }
    });
  }

  ngOnDestroy() {
    this.alertSubscription.unsubscribe();
  }

  navigateBackToExclusionList() {
    this.goBack.emit();
    return false;
  }
}
